export type CommissionLike = {
  status?: string | null
  paid_at?: string | null
  matured_at?: string | null
  matures_at?: string | null
  payout_id?: string | null
  period_end?: string | null
}

export type CommissionStage = 'pending' | 'matured' | 'paid' | 'canceled' | 'other'

function parseDate(value?: string | null): Date | null {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  return d
}

export function getCommissionMaturityDate(row: CommissionLike): Date | null {
  const maturesAt = parseDate(row?.matures_at || null)
  const maturedAt = parseDate(row?.matured_at || null)
  // Regra de negocio: a coluna "Matura em" da UI usa matures_at.
  // Entao o mes de referencia da maturacao deve priorizar matures_at,
  // e usar matured_at apenas como fallback quando matures_at nao existir.
  if (maturesAt) return maturesAt
  if (maturedAt) return maturedAt
  return null
}

export function getCommissionStage(row: CommissionLike, nowMs: number = Date.now()): CommissionStage {
  const raw = String(row?.status || '').toLowerCase()
  const isPaid = !!row?.paid_at || raw === 'paid'

  if (raw === 'void' || raw === 'canceled') return 'canceled'
  if (isPaid) return 'paid'

  const maturityDate = getCommissionMaturityDate(row)
  if (!maturityDate) {
    if (raw === 'earned' || raw === 'matured') return 'matured'
    if (raw === 'pending') return 'pending'
    return 'other'
  }

  return maturityDate.getTime() <= nowMs ? 'matured' : 'pending'
}

export function isCommissionPaid(row: CommissionLike, nowMs?: number): boolean {
  return getCommissionStage(row, nowMs) === 'paid'
}

export function isCommissionMatured(row: CommissionLike, nowMs?: number): boolean {
  return getCommissionStage(row, nowMs) === 'matured'
}

export function getCommissionMaturityAnchor(row: CommissionLike): Date | null {
  return getCommissionMaturityDate(row)
}
